import { useContext, useState } from "react";
import { FirebaseAuthContext } from "../../../../commons/firebase/FirebaseAuthProvider";
import { useSnackbar } from "notistack";
import {
    browserName,
    browserVersion,
    osName,
    osVersion,
} from "react-device-detect";

// Hook for submitting the player inputs at the end of the video and receive evaluated info
// about the player's performance for the session
const useSubmitData = () => {
    const { signedInUser } = useContext(FirebaseAuthContext);

    const { enqueueSnackbar } = useSnackbar();

    const [feedbackResult, setFeedbackResult] = useState([]);

    const [loadingFeedback, setLoadingFeedback] = useState(true);

    const savePlayerInputs = async (
        playerInputs,
        courseId,
        playlistId,
        scoredSceneId,
        feedbackMode,
        sessionType,
        isReplay
    ) => {
        const idToken = await signedInUser.getIdToken();
        fetch("/reg-main/statistics", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                idToken: idToken,
                feedbackMode: feedbackMode,
                playerInputData: {
                    userId: signedInUser.uid,
                    courseId: courseId,
                    playlistId: playlistId,
                    scoredSceneId: scoredSceneId,
                    playerInputs: playerInputs,
                    sessionType: sessionType,
                    isReplay: isReplay,
                    clientInfo: {
                        browser: browserName,
                        browserVersion: browserVersion,
                        platform: osName,
                        platformVersion: osVersion,
                        screenWidth: window.innerWidth,
                        screenHeight: window.innerHeight,
                    },
                },
            }),
        }).then(async (data) => {
            if (data.status === 200) {
                const feedbackJson = await data.json();
                setFeedbackResult(feedbackJson);
                setLoadingFeedback(false);
            } else {
                enqueueSnackbar("Something went wrong while saving your decisions.", {
                    variant: "error",
                    preventDuplicate: true,
                    autoHideDuration: 5000,
                });
            }
        });
    };
    /** */

    return { savePlayerInputs, loadingFeedback, feedbackResult };
};

export default useSubmitData;
